export const GET_SALES_PRODUCTS = 'GET_SALES_PRODUCTS';
export const UPDATE_SALES_PRODUCT = 'UPDATE_SALES_PRODUCT';
export const GET_PRODUCTS_BY_SKU = 'GET_PRODUCTS_BY_SKU';
export const UPDATE_COST = 'UPDATE_COST';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const CREATE_NEW_ORDER = 'CREATE_NEW_ORDER';
export const CLEAR_CREATE_ERRORS = 'CLEAR_CREATE_ERRORS';
export const GET_ALL_SALES_PRODUCTS = 'GET_ALL_SALES_PRODUCTS';
export const GET_PRODUCTS_INFO = 'GET_PRODUCTS_INFO';
export const GET_NEW_SEARCH_PRODUCTS = 'GET_NEW_SEARCH_PRODUCTS';
